import { CardViewIcon } from "@/domains/icons/huge-icons/monotone/card-view"

import { SwitchWithLabel } from "./switch-with-label"

export const SwitchCardView = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return (
    <SwitchWithLabel
      iconLeft={<CardViewIcon size={16} />}
      label="Card view"
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  )
}
